import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { NestedTreeControl } from '@angular/cdk/tree';
import {
  MatTreeNestedDataSource,
  MatTree,
  MatTreeNodeDef,
  MatNestedTreeNode,
  MatTreeNodeToggle,
  MatTreeNodeOutlet,
} from '@angular/material/tree';
import { ApiService } from 'src/app/services/api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-move-wiki-item-dialog',
  templateUrl: './move-wiki-item-dialog.component.html',
  styleUrls: ['./move-wiki-item-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatTree,
    MatTreeNodeDef,
    MatNestedTreeNode,
    NgClass,
    MatIconButton,
    MatTreeNodeToggle,
    MatIcon,
    MatButton,
    MatTreeNodeOutlet,
    MatDialogActions,
  ],
})
export class MoveWikiItemDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<MoveWikiItemDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private api = inject(ApiService);

  wikiTree: any;
  treeControl = new NestedTreeControl<any>(node => node.children);
  dataSource = new MatTreeNestedDataSource<any>();
  selectedNode: any;

  ngOnInit(): void {
    this.fetchWikiTree();
  }

  private fetchWikiTree() {
    this.api.getWikiTree().subscribe(data => {
      this.wikiTree = data;
      this.dataSource.data = this.wikiTree;
    });
  }

  selectItem(item: any) {
    this.selectedNode = item;
  }

  hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;

  isLeaf = (_: number, node: any) => !node.children || node.children.length === 0;

  close() {
    this.dialogRef.close();
  }

  move() {
    this.dialogRef.close(this.selectedNode);
  }
}
